import { SxProps } from "@mui/material";

export const EllipsesStyle: SxProps | undefined = {
    maxWidth: "250px",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden"
}